import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type PaymentStatus = "active" | "expiring" | "expired" | "none";

interface AttendanceStatusBadgeProps {
  status: PaymentStatus;
  daysRemaining?: number;
  className?: string;
}

const statusConfig: Record<PaymentStatus, { label: string; className: string }> = {
  active: {
    label: "Al día",
    className: "bg-green-500/20 text-green-400 border-green-500/30 hover:bg-green-500/30",
  },
  expiring: {
    label: "Por vencer",
    className: "bg-yellow-500/20 text-yellow-400 border-yellow-500/30 hover:bg-yellow-500/30",
  },
  expired: {
    label: "Vencido",
    className: "bg-red-500/20 text-red-400 border-red-500/30 hover:bg-red-500/30",
  },
  none: {
    label: "Sin pagos",
    className: "bg-gray-500/20 text-gray-400 border-gray-500/30 hover:bg-gray-500/30",
  },
};

export const AttendanceStatusBadge = ({
  status,
  daysRemaining,
  className,
}: AttendanceStatusBadgeProps) => {
  const config = statusConfig[status];
  
  let label = config.label;
  if (status === "expiring" && daysRemaining !== undefined) {
    label = `${daysRemaining}d restantes`;
  }

  return (
    <Badge
      variant="outline"
      className={cn("text-xs border", config.className, className)}
    >
      {label}
    </Badge>
  );
};
